export default __webpack_public_path__ + "static/media/cal-img.a4195681.png";